const ACCESS_LABEL_KEYS = {
  wrd: "advisor_history_page.accessAdmin",
  rw: "advisor_history_page.accessReadWrite",
  r: "advisor_history_page.accessReadOnly",
};

const AVATAR_COLORS = [
  "#4400aa",
  "#0d9488",
  "#ea580c",
  "#7c3aed",
  "#2563eb",
  "#db2777",
];

export const accessLevelLabelKey = (code) =>
  ACCESS_LABEL_KEYS[code] || ACCESS_LABEL_KEYS.r;

/** Hide empty Advisor sessions (e.g. "New chat" with no messages). */
export const hasAdvisorSessionMessages = (session) =>
  Number(session?.messageCount ?? session?.message_count ?? 0) > 0;

export const userInitials = (fullName, email) => {
  const source = (fullName || email || "?").trim();
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
  }
  return source.slice(0, 2).toUpperCase();
};

export const avatarColorForUser = (userId) => {
  const str = String(userId || "");
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash + str.charCodeAt(i) * (i + 1)) % AVATAR_COLORS.length;
  }
  return AVATAR_COLORS[hash];
};

export const formatSessionDateTime = (isoOrMs, locale = "tr-TR") => {
  if (!isoOrMs) return "";
  const date = typeof isoOrMs === "number" ? new Date(isoOrMs) : new Date(isoOrMs);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

export const formatRelativeActivity = (iso, t, locale = "tr-TR") => {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  const diffMs = Date.now() - date.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return t("advisor_history_page.activityJustNow");
  if (diffMin < 60) {
    return t("advisor_history_page.activityMinutesAgo", { count: diffMin });
  }
  const diffHours = Math.floor(diffMin / 60);
  if (diffHours < 24) {
    return t("advisor_history_page.activityHoursAgo", { count: diffHours });
  }
  return formatSessionDateTime(date.getTime(), locale);
};

export const routeContextLabel = (lastRoute) => {
  if (!lastRoute || typeof lastRoute !== "string") return null;
  const dash = lastRoute.match(/\/console\/Dashboard\/(\d+)/i);
  if (dash) {
    return { type: "dashboard", id: dash[1], label: `VoC Dashboard · ID ${dash[1]}` };
  }
  if (lastRoute.includes("/console/advisor")) {
    return { type: "advisor", label: "Advisor" };
  }
  if (lastRoute.includes("/console/my-workspace")) {
    return { type: "workspace", label: "My Workspace" };
  }
  return { type: "route", label: lastRoute };
};

export const exportOrgSessionsCsv = (sessions, t) => {
  const header = [
    t("advisor_history_page.csvUser"),
    t("advisor_history_page.csvEmail"),
    t("advisor_history_page.csvTitle"),
    t("advisor_history_page.csvUpdated"),
    t("advisor_history_page.csvMessages"),
    t("advisor_history_page.csvRoute"),
  ];
  const rows = sessions.map((s) => [
    s.user?.full_name || "",
    s.user?.email || "",
    s.title || "",
    s.updated_at || "",
    String(s.message_count ?? ""),
    s.last_route || "",
  ]);
  const escape = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;
  const lines = [header, ...rows].map((row) => row.map(escape).join(","));
  const blob = new Blob([`\uFEFF${lines.join("\n")}`], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `pivony-advisor-history-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};
